import * as React from 'react';
import { ContentfulDownloadSoftwareContainer, ContentfulDownloadSoftware } from '../../../interfaces';
import DownloadSoftware from '../download-software/download-software';
import { RichTextRenderer } from '../shared/rich-text-renderer';
import { fetchSoftwareVersions, Products } from '../../../api/software-version-api.service'; 
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { withContentfulLivePreviewSys } from '../../../utils/with-contentful-live-preview-sys';

import './download-software-container.scss';

export default function DownloadSoftwareContainer(props: ContentfulDownloadSoftwareContainer) {
  const liveData = useContentfulLiveUpdates(withContentfulLivePreviewSys(props));

  const { 
    title,
    subtitle,
    categoryTitle,
    softwareItems,
    softwareAdditionalInfo,
    contentful_id
  } = liveData;

  const inspector = useContentfulInspectorMode(
    contentful_id ? { entryId: contentful_id } : undefined
  );

  const titleInspector = inspector({ fieldId: 'text', entryId: title?.contentful_id });
  const subtitleInspector =  inspector({ fieldId: 'text', entryId: subtitle?.contentful_id });
  const categoryInspector = inspector({ fieldId: 'text', entryId: categoryTitle?.contentful_id });
  const additionalInfoInspector = inspector({ fieldId: 'text', entryId: softwareAdditionalInfo?.contentful_id });

  const pageTitle = title?.text || '';
  const pageSubtitle = subtitle?.text?.raw ?? subtitle?.text?.json;
  const titleCategory = categoryTitle?.text || '';
  const additionalInfoText = softwareAdditionalInfo?.text?.raw ?? softwareAdditionalInfo?.text?.json;

  if (!softwareItems || softwareItems.length === 0) return null;

  return (
    <div className="download-softwares-container">
      {pageTitle &&
        <h2 className='download-softwares-container__title' {...titleInspector}>{pageTitle}</h2>
      }

      {pageSubtitle && (
        <div className="download-softwares-container__subtitle" {...subtitleInspector} >
          <RichTextRenderer raw={pageSubtitle} />
        </div>
      )}

      <div className="download-softwares-container__section">
        {titleCategory && <h2 className='download-softwares-container__category' {...categoryInspector} >{titleCategory}</h2>}

        <div className='download-softwares-container__list'>
          {softwareItems.map((software, index) => {
            if (!software) return null;

            return (
              <DownloadSoftware
                key={`software-${index}`}
                {...software as ContentfulDownloadSoftware}
              />
            );
          })}
        </div>
      </div>

      {additionalInfoText && (
        <div className='download-softwares-container__additional-info' {...additionalInfoInspector} >
          <RichTextRenderer raw={additionalInfoText} />
        </div>
      )}
    </div>
  );
}